import gql from "graphql-tag";

export const createCompte = gql`
  mutation createCompte($utilisateurId: Int!) {
    createCompte(utilisateurId: $utilisateurId) {
      type
      message
      details
    }
  }
`;

export const disableSheets = gql`
  mutation disableSheets($utilisateurId: Int!) {
    disableSheets(utilisateurId: $utilisateurId) {
      type
      message
      details
    }
  }
`;

export const toggleCompte = gql`
  mutation toggleCompte($utilisateurId: Int!, $identifiant: String!) {
    toggleCompte(utilisateurId: $utilisateurId, identifiant: $identifiant) {
      type
      message
      details
    }
  }
`;

export const toggleSheetsCompte = gql`
  mutation toggleSheetsCompte($utilisateurId: Int!, $identifiant: String!) {
    toggleSheetsCompte(
      utilisateurId: $utilisateurId
      identifiant: $identifiant
    ) {
      type
      message
      details
    }
  }
`;

export const refreshComptes = gql`
  mutation refreshComptes($utilisateurId: Int!) {
    refreshComptes(utilisateurId: $utilisateurId) {
      type
      message
      details
    }
  }
`;

export const forceRefreshCompte = gql`
  mutation forceRefreshCompte($utilisateurId: Int!, $identifiant: String!) {
    forceRefreshCompte(
      utilisateurId: $utilisateurId
      identifiant: $identifiant
    ) {
      type
      message
      details
    }
  }
`;

export const deleteCompte = gql`
  mutation deleteCompte($utilisateurId: Int!, $identifiant: String!) {
    deleteCompte(utilisateurId: $utilisateurId, identifiant: $identifiant) {
      type
      message
      details
    }
  }
`;
